export default {
  status: false,
  type: undefined,
  invitationData: {},
};
